import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "sec-main"
}
const _hoisted_2 = { class: "accelerator-main pb-0" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "資源搜尋 - 新創夥伴快搜", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-10 mx-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 text-primary mb-4" }, "新創夥伴快搜", -1)
const _hoisted_12 = { class: "select-filter border" }
const _hoisted_13 = { class: "select-filter-wrapper py-md-5 p-4" }
const _hoisted_14 = { class: "col-sm-6 col-xl mb-xl-0 mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "techFieldId",
  class: "h3 form-label"
}, "技術應用領域", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "請選擇", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-sm-6 col-xl mb-xl-0 mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "cityId",
  class: "h3 form-label"
}, "所在城市", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "請選擇", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "col-sm-12 col-xl-4 mb-xl-0 mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "keywordId",
  class: "h3 form-label"
}, "關鍵字搜尋", -1)
const _hoisted_26 = { class: "col col-xl-auto d-flex justify-content-center align-self-xl-end my-md-1" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-sm-10 mx-auto" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 text-primary mb-4" }, "新創夥伴快搜", -1)
const _hoisted_31 = {
  key: 0,
  class: "row"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 mx-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "startupR-alert-info startupR-alert-guide bg-white py-3 mx-auto text-center" }, "查無符合條件的廠商")
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "lists-group" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "fcsb flex-md-row gap-3" }
const _hoisted_37 = { class: "h3 flex-grow-1 order-md-0 order-1" }
const _hoisted_38 = { class: "frcs flex-wrap gap-2 flex-shrink-0" }
const _hoisted_39 = { class: "h5 w-md-85 my-3" }
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = { class: "fcsb flex-md-row gap-2" }
const _hoisted_42 = { class: "funds-list fcss flex-lg-row" }
const _hoisted_43 = { class: "funds-source-group frcs flex-wrap border-0 p-0 m-0" }
const _hoisted_44 = { class: "h5 ps-md-2 ps-1 pe-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "link-anchor"
}, "詳細內容", -1)
const _hoisted_46 = { class: "row mt-0" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = {
  class: "modal fade",
  id: "startupResourcesModal",
  tabindex: "-1",
  "aria-labelledby": "startupResourcesModalLabel",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = {
  key: 0,
  class: "company-intro-main"
}
const _hoisted_52 = { class: "fcsb flex-md-row gap-3 mb-4" }
const _hoisted_53 = { class: "d-grid gap-3 flex-grow-1 order-1 order-md-0" }
const _hoisted_54 = { class: "h2 mb-1 text-primary" }
const _hoisted_55 = { class: "row fcss flex-md-row" }
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "公司成立年份", -1)
const _hoisted_58 = { class: "h4" }
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "所在城市", -1)
const _hoisted_61 = { class: "h4" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "技術應用領域", -1)
const _hoisted_64 = { class: "funds-list fcss flex-lg-row" }
const _hoisted_65 = { class: "funds-source-group tech-field-grid border-0 p-0 m-0" }
const _hoisted_66 = { class: "h5 ps-md-2 ps-1 pe-md-3" }
const _hoisted_67 = {
  key: 0,
  class: "tutor-item-logo flex-shrink-0"
}
const _hoisted_68 = ["src", "alt"]
const _hoisted_69 = { class: "mb-4" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "公司簡介", -1)
const _hoisted_71 = {
  class: "h4",
  style: {"white-space":"pre-line"}
}
const _hoisted_72 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "公司官網", -1)
const _hoisted_74 = ["href"]
const _hoisted_75 = { class: "mb-4" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "參與新竹新創計畫", -1)
const _hoisted_77 = { class: "frcs flex-wrap gap-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "link-text btn-primay head-label",
    "data-bs-dismiss": "modal"
  }, "關閉視窗")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination_component = _resolveComponent("pagination-component")!
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("form", {
                  class: "row",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("select", {
                      id: "techFieldId",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.techField) = $event))
                    }, [
                      _hoisted_16,
                      _createElementVNode("option", { value: _ctx.allOptionValue }, "不限", 8, _hoisted_17),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.techFieldList, (t) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: t,
                          value: t
                        }, _toDisplayString(t), 9, _hoisted_18))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.searchForm.techField]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("select", {
                      id: "cityId",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.city) = $event))
                    }, [
                      _hoisted_21,
                      _createElementVNode("option", { value: _ctx.allOptionValue }, "不限", 8, _hoisted_22),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityOptions, (c) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: c,
                          value: c
                        }, _toDisplayString(c), 9, _hoisted_23))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.searchForm.city]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                      id: "keywordId",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.keyword) = $event)),
                      class: "form-control",
                      type: "text",
                      placeholder: "關鍵字搜尋"
                    }, null, 512), [
                      [_vModelText, _ctx.searchForm.keyword]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn-primay filled",
                      disabled: !_ctx.hasSearchCondition
                    }, "查詢", 8, _hoisted_27)
                  ])
                ], 32)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (_ctx.searched && _ctx.paged.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paged, (company) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: company.id,
                  class: "list-card mb-md-3 mb-2"
                }, [
                  _createElementVNode("div", {
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#startupResourcesModal",
                    onClick: ($event: any) => (_ctx.select(company))
                  }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(company.name), 1),
                      _createElementVNode("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.plans, (p) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: p,
                            class: _normalizeClass(['tag', _ctx.planClass(p), 'active', 'px-3', 'py-md-0', 'py-1'])
                          }, _toDisplayString(_ctx.planLabel(p)), 3))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(company.description), 1),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTags(company), (tag, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: tag + i,
                                class: _normalizeClass(['funds-source', 'frcs', 'me-3', 'mb-md-0', 'mb-2', i === 2 ? 'd-none d-md-flex' : ''])
                              }, [
                                _createElementVNode("div", _hoisted_44, _toDisplayString(tag), 1)
                              ], 2))
                            }), 128))
                          ])
                        ]),
                        _hoisted_45
                      ])
                    ])
                  ], 8, _hoisted_35)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_pagination_component, {
              class: "pagination-component",
              totalPages: _ctx.totalPages,
              onOnClick: _ctx.changePage
            }, null, 8, ["totalPages", "onOnClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          (_ctx.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("h2", _hoisted_54, _toDisplayString(_ctx.selected.registeredName || _ctx.selected.name), 1),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.selected.foundedYear || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.selected.city || '-'), 1)
                      ])
                    ]),
                    (_ctx.modalTags(_ctx.selected).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalTags(_ctx.selected), (tag, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: tag + i,
                                  class: "funds-source frcs"
                                }, [
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(tag), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.selected.file && _ctx.selected.file.path)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("img", {
                          src: _ctx.selected.file.path,
                          alt: _ctx.selected.registeredName || _ctx.selected.name,
                          class: "img-fluid"
                        }, null, 8, _hoisted_68)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.selected.description), 1)
                  ])
                ]),
                (_ctx.selected.website)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("a", {
                        class: "h4 text-primary",
                        href: _ctx.selected.website,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, [
                        _createElementVNode("u", null, _toDisplayString(_ctx.selected.website), 1)
                      ], 8, _hoisted_74)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("div", _hoisted_77, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.plans, (p) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: p,
                        class: _normalizeClass(['d-inline-block', 'tag', _ctx.planClass(p), 'active', 'px-3', 'py-md-0', 'py-1'])
                      }, _toDisplayString(_ctx.planLabel(p)), 3))
                    }), 128))
                  ])
                ]),
                _hoisted_78
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ])), [
    [_directive_title, '新創夥伴快搜']
  ])
}